import { SmallPenIcon } from '@systemeio/ui/icons';
import { FormInput, NeutralButton } from '@systemeio/ui';
import { updateCampaign } from 'modules/campaigns/api/campaign-api';
import { defaultCampaignErrors } from 'modules/campaigns/constants';
import { CampaignErrorsInterface, CampaignParametersApiInterface, CampaignUpdateInterface } from 'modules/campaigns/types/campaign-interface';
import { useCallback, useState } from 'react';
import EditModal, { EditDataType } from 'shared/components/edit-modal';
import FormTextarea from 'shared/components/form-textarea';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { fetchWithErrors } from 'shared/utils/fetch-with-errors';
import { KeyedMutator } from 'swr';
import { useRevalidateModules } from '@systemeio/util';
import { RequestModuleEnum } from 'shared/enums/request-module-enum';
export const EditCampaignModal = ({
  campaignParameters,
  mutateCampaignParameters
}: {
  campaignParameters?: CampaignParametersApiInterface;
  mutateCampaignParameters: KeyedMutator<CampaignParametersApiInterface>;
}) => {
  const {
    t
  } = useLocoTranslation();
  const [isModalOpened, setIsModalOpened] = useState<boolean>(false);
  const [errors, setErrors] = useState<CampaignErrorsInterface>(defaultCampaignErrors);
  const {
    revalidateModules
  } = useRevalidateModules();
  const onModalClose = () => setErrors(defaultCampaignErrors);
  const onEdit = useCallback(async (editedCampaign: EditDataType<CampaignUpdateInterface>) => campaignParameters && (await fetchWithErrors(async () => {
    await updateCampaign(campaignParameters.id, editedCampaign);
    await mutateCampaignParameters();
    await revalidateModules([RequestModuleEnum.Campaign]);
  }, setErrors)), [campaignParameters, mutateCampaignParameters]);
  return <>
      <NeutralButton onClick={() => {
      setIsModalOpened(true);
    }} disabled={!campaignParameters}>
        <SmallPenIcon />
        <span className="hidden sm:flex">
          {t('global.edit', {
          module: t('dashboard.campaign.title').toLowerCase()
        })}
        </span>
      </NeutralButton>

      {campaignParameters ? <EditModal instance={campaignParameters} caption={t('dashboard.campaign.title')} opened={isModalOpened} onClose={() => {
      setIsModalOpened(false);
    }} afterLeave={onModalClose} editable={[{
      field: 'name',
      onRender: (value, onChange) => <FormInput key="campaign-name-edit" placeholder={t('global.name')} value={value} onChange={e => onChange(e.target.value)} error={errors.name} label={t('global.name')} />
    }, {
      field: 'description',
      onRender: (value_0, onChange_0) => <FormTextarea key="campaign-description-edit" onChange={e_0 => onChange_0(e_0.target.value)} placeholder={t('global.description')} value={value_0 || ''} label={t('global.description')} error={errors.description} className={'min-h-[126px]'} />
    }]} onEdit={onEdit} /> : null}
    </>;
};